itsoftApp.createModule("backToPrevPage", function() {
    var module = this;
    var backBtn = document.querySelectorAll('.js-back-to-page');

    var initBackToPrevPage = function () {
        if (backBtn) {
            backBtn.forEach((btn) => {
                var backBtnHref = btn.getAttribute('data-href');
                var referrer = document.referrer;
                if (referrer === '') {
                    btn.setAttribute('href', backBtnHref)
                } else {
                    btn.setAttribute('href', referrer)
                } 
            });
        }
    }

    initBackToPrevPage();

    module.callback = initBackToPrevPage;
});